import { memo, RefAttributes } from 'react';
import { Modal as RACModal, ModalOverlayProps } from 'react-aria-components';

import { merge } from '@/components';

export type ModalProps = ModalOverlayProps & RefAttributes<HTMLDivElement>;

const IModal = ({ className, children, ...rest }: ModalProps) => {
  return (
    <RACModal
      className={({ isEntering, isExiting }) => {
        return merge(
          'rounded-lg border-1 border-gray-200 bg-white shadow-lg',
          isEntering && 'animate-in zoom-in-95 duration-300 ease-out',
          isExiting && 'animate-out zoom-out-95 duration-200 ease-in',
          className
        );
      }}
      {...rest}
    >
      {children}
    </RACModal>
  );
};

export const Modal = memo(IModal) as typeof IModal;
